<template>
  <li class="nav-item align-self-center cursor-pointer"
      v-if="$auth.can({distributor_client_ui: 'read'}, 'permissions')">
    <el-tooltip :content="$t('distributorClientUI.title')"
                effect="light"
                :open-delay="300"
                placement="bottom">

      <base-button
        :loading="loading"
        icon
        link
        @click.native="handleNavigateToDistributorClientUI()"
      ><i class="mdi mdi_icon mdi-24px mdi-point-of-sale"/>
      </base-button>
    </el-tooltip>
  </li>

</template>
<script>

import {mapActions, mapState} from "vuex";

export default {
  name: 'distributor-client-ui-nav',
  computed: {
    ...mapState({
      loading: state => state.distributor_client_ui.loading,
      auth: state => state.distributor_client_ui.auth,
      darkModeTheme: state => state.app.darkMode,
      currentLocale: state => state.app.locale,
    }),
  },
  data() {
    return {
      distributorClientUiUrl: process.env.VUE_APP_DISTRIBUTOR_CLIENT_UI_URL,
      distributorClientUiLinkUrl: ''
    };
  },
  methods: {
    ...mapActions(['GetDistributorClientUi']),
    handleNavigateToDistributorClientUI() {
      this.GetDistributorClientUi();
    },
    navigateToDistributorClientUI() {
      window.open(this.distributorClientUiLinkUrl, '_blank')
    }
  },
  watch: {
    auth(value) {
      let encodedStringBtoA = btoa(JSON.stringify({
        auth: value,
        system_account_email: this.$auth.user()["email"],
        locale: this.currentLocale,
        dark_mode: this.darkModeTheme
      }));
      this.distributorClientUiLinkUrl = this.distributorClientUiUrl + '?d=' + encodedStringBtoA; // d=details
      this.navigateToDistributorClientUI()
    }
  }
};
</script>
